import React from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'



export interface IBarPieProps {
  xData?: string[];
  yData?: number[][];
  color?: string[];
  legendData?: string[];
  formatter: string | ((params: Array<any>, ticket: string) => string | HTMLElement | HTMLElement[]);
}

export const BarChart = (props: IBarPieProps) => {
  const {
    legendData = ['付款', '收款', '收款占比', '付款占比'],
    xData = [],
    yData = [[], [], [], []],
    color = ['#C490BF', '#B3D465', '#C490BF', '#B3D465'],
    formatter,
  } = props
  const getOption = () => {
    return {
      color,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          }
        },
        formatter,
        textStyle: {
          fontSize: 12
        }
      },
      grid: {
        left: 60,
        right: 50,
      },
      legend: {
        data: legendData,
        right: 10,
        top: 0,
      },
      xAxis: [
        {
          type: 'category',
          data: xData,
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            rotate: -45,
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: '(人)',
          nameTextStyle: {
            align: "right",
          },
          min: 0,
          // max: 25,
          // interval: 5,
          axisLabel: {
            formatter: '{value}'
          }
        },
        {
          type: 'value',
          name: '  (占比)',
          nameTextStyle: {
            align: "left",
          },
          min: 0,
          max: 100,
          // interval: 20,
          axisLabel: {
            formatter: '{value} %'
          }
        }
      ],
      series: [
        {
          name: legendData[0],
          type: 'bar',
          data: yData[0],
        },
        // {
        //   name: legendData[1],
        //   type: 'bar',
        //   data: yData[1]
        // },
        {
          name: legendData[1],
          type: 'line',
          yAxisIndex: 1,
          data: yData[1]
        },
        // {
        //   name: legendData[3],
        //   type: 'line',
        //   yAxisIndex: 1,
        //   data: yData[3]
        // }
      ]
    }
  }
  return (
    <ReactEchartsCore
      echarts={echarts}
      theme="light"
      option={getOption()}
      style={{ height: '100%', marginTop: '10px' }}
    />
  )
}